import React, {ReactNode} from 'react';

import {translateCommentContentType} from 'app/acceptance/types';
import {LazyTooltip} from 'app/components/general/LazyTooltip';
import {ApproveButton} from 'app/procedures/components/page-headers/RequestOrApproveButton/ApproveButton';
import {gt} from 'app/utils/i18n';

import {ConfirmButton} from './ConfirmButton';

import type {
  AcceptanceSerializedType,
  AcceptanceStatusSerializedType,
} from 'sweet-types';

type Props = {
  acceptance: AcceptanceSerializedType;
  documentId: number;
  documentHtmlURL: string;
  status: AcceptanceStatusSerializedType;
  versionURL: string;
  versionApprovedAt: string | null;
  nextReviewDate: string | null;
};
export const AcceptSidebarActions = ({
  status,
  versionApprovedAt,
  acceptance,
  documentId,
  versionURL,
  documentHtmlURL,
  nextReviewDate,
}: Props) =>
  versionApprovedAt == null ? (
    <div className="py-3">
      <div className="small mb-1 px-3">
        {gt(
          'You can confirm your support for this draft or immediately approve it.'
        )}
      </div>

      <div className="px-4 mt-3">
        <ActionButtonLine
          helpContent={gt(
            'Confirming will indicate your support for this draft being approved.'
          )}
        >
          <ConfirmButton
            className="btn-sm btn-outline-primary btn-block"
            contentType={translateCommentContentType(acceptance.content_type)}
            documentId={documentId}
            acceptancestatus={status}
          />
        </ActionButtonLine>
        <ActionButtonLine
          helpContent={gt(
            'Approve this draft and make it the new live version'
          )}
        >
          <ApproveButton
            groupClass="btn-block"
            className="btn btn-outline-primary btn-sm"
            contentType={translateCommentContentType(acceptance.content_type)}
            documentId={documentId}
            documentHtmlURL={documentHtmlURL}
            versionURL={versionURL}
            disabled={versionApprovedAt != null}
            versionApprovedAt={versionApprovedAt}
            managers={[]}
            nextReviewDate={nextReviewDate}
            color="outline-primary"
            size="sm"
          />
        </ActionButtonLine>
      </div>
    </div>
  ) : null;
type ActionButtonLineProps = {
  children: ReactNode;
  helpContent: ReactNode;
};

function ActionButtonLine({children, helpContent}: ActionButtonLineProps) {
  return (
    <div className="d-flex align-items-center mb-3">
      <div className="flex-grow-1">{children}</div>
      <div className="pl-2 small text-muted">
        <LazyTooltip tooltip={helpContent}>
          <i className="ml-1 fa fa-question-circle" />
        </LazyTooltip>
      </div>
    </div>
  );
}
